export default __webpack_public_path__ + "static/highlighter_tool.4518fe02935182c2a6f094ea4c20c2cd.svg";